/**
 * Find all duplicates in an array. Returns a unique array of all duplicates.
 *
 * This cannot be called on arrays with non-primitive elements since it uses Set and would only use
 * shallow equality, which is likely not what the caller wants.
 */
export default function findDuplicates<T extends string | number | boolean | null>(
  array: Array<T>
): Array<T> {
  const duplicates = new Set<T>();
  const alreadyFound = new Set<T>();
  for (const item of array) {
    if (alreadyFound.has(item)) {
      duplicates.add(item);
    }
    alreadyFound.add(item);
  }
  return [...duplicates];
}
